// @flow
import React from 'react';
import katex from 'katex';
import 'katex/dist/katex.css';
import './katex-mathml-fix.css';

// <LatexInternal> is for programmer use only.
// It should NOT be exposed in the editor for content writers to use.

type Props = {|
  expression: string,
  displayMode?: boolean,
  fontSize?: number,
  style?: Object, // TODO flow type for react style objects?
|};

const LatexInternal = ({
  expression,
  displayMode = false,
  fontSize = 16,
  style = {},
}: Props) => {
  const ref = React.useRef(null);
  React.useLayoutEffect(() => {
    if (ref.current === null) return;
    katex.render(expression, ref.current, {
      throwOnError: false,
      displayMode: displayMode,
    });
  }, [expression]);
  return (
    <span
      style={{
        ...style,
        // Katex renders at 1.21 em, so we use the reciprocal in order
        // to render at the actual font size we selected.
        fontSize: fontSize / 1.21,
      }}
      ref={ref}
    >
      {expression}
    </span>
  );
};

export default LatexInternal;
